/**
 * Saves an axios `responseType: "blob"` response as a file.
 *
 * @param res       the axios response
 * @param filename  name to save under
 */
export function downloadBlob(res, filename) {
  const blob = new Blob([res.data], {
    type: res.headers?.["content-type"]
      || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}

/**
 * The server's message from a failed blob request. With responseType "blob"
 * the JSON error body arrives as a Blob, so it has to be read before it can be
 * shown.
 */
export async function blobErrorMessage(e, fallback = "Download failed") {
  const data = e?.response?.data;
  if (data instanceof Blob) {
    try {
      const text = await data.text();
      try { return JSON.parse(text)?.message || text || fallback; } catch { return text || fallback; }
    } catch { /* fall through */ }
  }
  return e?.response?.data?.message || e?.message || fallback;
}
